module.exports = __webpack_public_path__ + "static/media/inte_partenaires.d6b5b96c.mov";